import React from "react";
import { downloadFileByUrl } from "../../../../helpers/shared";

const DownloadButton = ({ fileUrl, fileName }) => {
    return (
        <button
            onClick={() => downloadFileByUrl(fileUrl, fileName)}
            className="flex items-center max-w-full px-1 md:px-3 lg:px-4 py-[10px] md:py-2 rounded-full ring-1 ring-[#6446C3] ring-inset ring-offset-0 text-[#6446C3] hover:bg-[#F4F0FF] transition overflow-hidden"
            style={{ minWidth: 0 }}
        >
            {/* Иконка */}
            <svg
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="flex-shrink-0 w-[14px] h-[14px] mr-1.5"
            >
                <path
                    d="M12.001 14.9425L12.001 3M12.001 3L7.06835 7.56318M12.001 3L16.9336 7.56318M4 18.9663V20.3827C4.40471 20.778 4.95361 21 5.52595 21H18.4741C19.0464 21 19.5953 20.778 20 20.3827V18.9663"
                    stroke="#6446C3"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>

            {/* Текст */}
            <div className="flex flex-col min-w-0">
                <div className="font-semibold text-[2.5vw] sm:text-xs md:text-sm leading-tight truncate">
                    Скачать {fileName}
                </div>
                <div className="text-[2vw] sm:text-[10px] text-[#B5A9E2] leading-tight truncate">
                    PDF Файл
                </div>
            </div>
        </button>
    );
};

export default DownloadButton;
